import { useSelector } from "react-redux"
import { getSubsidies } from "#/redux/reducers/subsidies"
import { useUserRole } from "#/components/partner-access/hooks/usePartnerAccess"
import { isCreditMember } from "#/components/views/molecules/subsidyCategoryGroups"
import { useDirectPayPrimaryServices } from "#/services/user/hooks/useDirectPayPrimaryServices"

// `=== false` waits for the role to load, so a partner never triggers the request.
export function usePreloadDirectPayPrimaryServices(): void {
  const subsidies = useSelector(getSubsidies)
  const { isPartnerAccessingAccount } = useUserRole()
  useDirectPayPrimaryServices({ enabled: isCreditMember(subsidies) && isPartnerAccessingAccount === false })
}
